

export class TyreModelOutputWithOutStatus implements ITyreModelOutputWithOutStatus {
    /** The auto-generated id of the tyre model master */
    tyre_model_id!: number;
    /** The tyre model name with 255 character limit */
    tyre_model_name!: string;

    constructor(data?: ITyreModelOutputWithOutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tyre_model_id = _data["tyre_model_id"];
            this.tyre_model_name = _data["tyre_model_name"];
        }
    }

    static fromJS(data: any): TyreModelOutputWithOutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TyreModelOutputWithOutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tyre_model_id"] = this.tyre_model_id;
        data["tyre_model_name"] = this.tyre_model_name;
        return data; 
    }
}

export interface ITyreModelOutputWithOutStatus {
    /** The auto-generated id of the tyre model master */
    tyre_model_id: number;
    /** The tyre model name with 255 character limit */
    tyre_model_name: string;
}

